<template>
	<div>
		<CardGrafico
			v-show="!reportMode"
			:title="$t('ima')"
			:subtitle="dataDoUltimoProcessamento"
		>
			<template #grafico>
				<Loading v-if="data.length === 0" />
				<div
					v-else
					class="container__graficofazenda"
				>
					<Chart
						ref="ref__chart"
						class="container__graficofazenda__grafico"
						:options="chartOptions"
					/>
				</div>
			</template>
		</CardGrafico>
		<Chart
			v-show="reportMode"
			ref="ref__chart"
			class="container__graficofazenda__grafico"
			:options="chartOptions"
		/>
	</div>
</template>

<script>
import { Chart } from 'highcharts-vue'
import Loading from '../Loading/Loading.vue'
import CardGrafico from '../../views/Dashboard/CardGrafico/CardGrafico.vue'

import { getColorHexByCSSVariable } from '../../utils/themesHelper'
// import { stringToExportCSV } from "../utils/csvHellpers";

import _ from 'lodash'

import randomcolor from 'randomcolor'

export default {
	components: {
		CardGrafico,
		Chart,
		Loading,
	},
	props: {
		reportMode: {
			type: Boolean,
			default: false,
		},
		/**
		 * Dados que devem ser passados para o componente
		 */
		data: {
			type: [Array, Object],
			required: true,
		},

		/**
		 * Data do ultimo processamento
		 */
		dataDoUltimoProcessamento: { type: String, require: true },
	},
	data() {
		return {
			chartOptions: {
				chart: {
					type: 'area',
				},
				/**
				 * Creditos no canto inferior direito do grafico
				 */
				credits: {
					enabled: false,
				},
				/**
				 * Não usar exportacao padrao do highcharts
				 */
				exporting: {
					enabled: false,
				},
				/**
				 * Deasbilitar legendas
				 */
				legend: {
					enabled: true,
				},
				/**
				 * Opcoes na hora de plotar o grafico
				 */
				plotOptions: {
					series: {
						/**
						 * Animacao de 2 segundos
						 */
						animation: {
							duration: 1000,
						},
					},
				},
				/**
				 * Dados que devem ser colocados no grafico
				 */
				series: [],
				/**
				 * Titulo do grafico
				 */
				title: {
					text: this.reportMode ? this.$t('historicalAAI') : '',
				},
				/**
				 * Balão ao passar o mouse sobre as barras
				 */
				tooltip: {
					// formatter: function () {
					//   let result = `
					//     <div class="container__graficofazenda__tooltip">
					//         <div class="container__graficofazenda__tooltip__fazenda">
					//             <div class="container__graficofazenda__tooltip__fazenda__nome"> ${this.point.options.fazenda.nome}</div> <br/>
					//             <div class="container__graficofazenda__tooltip__fazenda__info">
					//               <span>Idade dos Plantios</span>
					//               <span>${this.point.options.fazenda.idade} (ano)</span>
					//             </div>
					//             <div class="container__graficofazenda__tooltip__fazenda__info">
					//               <span>Volume Total</span>
					//               ${this.point.options.fazenda.volumeTotal} (m³)
					//             </div>
					//             <div class="container__graficofazenda__tooltip__fazenda__info">
					//               <span>Volume Médio</span>
					//               ${this.point.options.fazenda.volumeMedio} (m³/ha)
					//             </div>
					//             <div class="container__graficofazenda__tooltip__fazenda__info">
					//               <span>Incremento Médio Anual</span>
					//               ${this.point.options.fazenda.incrementoMedioAnual} (m³/ha/ano)
					//             </div>
					//         </div>
					//     </div>`;

					//   return result;
					// },
					backgroundColor: '#333647',
					borderRadius: 10,
					borderWidth: 0,
					outside: true,
					shadow: false,
					useHTML: true,
				},
				/**
				 * Eixo X
				 */
				xAxis: {
					type: 'datetime',

					// allowDecimals: false,
					title: {
						text: this.$t('date'),
						style: {
							fontFamily: 'Open Sans, sans-serif',
							fontSize: '.8rem',
							fontWeight: 600,
						},
					},
					labels: {
						format: '{value:%e %b %Y}',
						style: {
							color: '#01395e',
							fontFamily: 'Open Sans, sans-serif',
							fontSize: '.8rem',
							fontWeight: 700,
						},
					},
				},
				/**
				 * Eixo Y
				 */
				yAxis: {
					title: {
						text: 'Volume',
						style: {
							fontFamily: 'Open Sans, sans-serif',
							fontSize: '.8rem',
							fontWeight: 600,
						},
					},
					gridLineColor: 'rgba(var(--color-rgb-gray), .2)',
					labels: {
						style: {
							color: '#01395e',
							fontFamily: 'Open Sans, sans-serif',
							fontSize: '.8rem',
							fontWeight: 700,
						},
					},
				},
			},
			/**
			 * Diferentes series para serem aplicados quando selecionar o filtro
			 */
			allSeries: [],
			/**
			 * Tipo do gráfico que deve ser exibido
			 */
			dropdownTipoGrafico: '',
			/**
			 * Opção selecionada para o download
			 */
			dropdownDownload: '',
			/**
			 * Filtro para esconder ou mostrar dados da fazenda no grafico
			 */
			filtroFazendas: [],
			/**
			 * Filtro do inputSearch
			 */
			textFilter: '',
		}
	},
	computed: {},
	watch: {
		/**
		 * Sempre que o data mudar ira renderizar o grafico novo
		 */
		data() {
			this.filtroFazendas = []
			this.setarObjetosParaOGrafico()
			this.dropdownTipoGrafico = 'volumeTotal'
		},

		/**
		 * Seta o novo serie para o highchart
		 */
		dropdownTipoGrafico() {
			this.changeHighchartsOptions()
		},

		/**
		 * Seleciona a opcao de download escolhida
		 */
		// dropdownDownload(type) {
		//   if (type) {
		//     const filename = `${new Date().getTime()}`;
		//     if (type === "text/csv") {
		//       const csv = this.$refs.ref__chart.chart.getCSV();
		//       stringToExportCSV(filename, csv);
		//     } else {
		//       this.$refs.ref__chart.chart.exportChart({ filename, type });
		//     }
		//     this.dropdownDownload = "";
		//   }
		// },
	},
	methods: {
		/**
		 * Adiciona serie que são os dados que o highcharts precisa para renderizar o grafico
		 */
		addToAllSeries(historicoFazenda, nome, color) {
			const fazenda = historicoFazenda[0].nome

			const serie = {
				color,
				name: nome,
				data: [],
				dataLabels: {
					enabled: true,
					format: `{y} (m³/ha)`,
					style: {
						fontFamily: 'Open Sans, sans-serif',
						fontWeight: 400,
						fontSize: '0.75rem',
					},
				},
				id: nome,
			}

			historicoFazenda.forEach((fazenda) => {
				serie.data.push([new Date(fazenda.dataMedicao).getTime(), fazenda.media])
			})

			this.allSeries.push({ fazenda, serie })
		},
		/**
		 * Adiciona a legenda para o grafico, sendo possivel filtrar o grafico atraves das legendas
		 */
		addFiltroFazenda(historicoFazenda, color) {
			historicoFazenda = _.orderBy(historicoFazenda, 'idade', 'desc')

			const filtroFazenda = {
				color,
				isChecked: true,
				label: historicoFazenda[0].nome,
				volumeMedio: parseFloat(historicoFazenda[0].volumeMedio.toFixed(2)),
				volumeTotal: parseFloat(historicoFazenda[0].volumeTotal.toFixed(2)),
				incrementoMedioAnual: parseFloat(historicoFazenda[0].incrementoMedioAnual.toFixed(2)),
			}

			this.filtroFazendas.push(filtroFazenda)
		},
		/**
		 * Metodo que vai iterar sobre o data para criar os objetos necessarios
		 * para o componente do Gráfico e do Filtro
		 */
		setarObjetosParaOGrafico() {
			// const agrupadoPorFazenda = _.groupBy(this.data, (data) => data.id);

			const rgbDefaultColor = getColorHexByCSSVariable('--color-default')
			const rgbPrimaryColor = getColorHexByCSSVariable('--color-primary')

			const { imaVtcc, imaVtsc } = this.data
			console.log(
				'🚀 ~ file: GraficoIMA.vue ~ line 258 ~ setarObjetosParaOGrafico ~ imaVtsc',
				imaVtsc,
			)
			console.log(
				'🚀 ~ file: GraficoIMA.vue ~ line 258 ~ setarObjetosParaOGrafico ~ imaVtcc',
				imaVtcc,
			)

			this.addToAllSeries(
				imaVtcc,
				this.$t('withBark'),
				randomcolor({
					luminosity: 'bright',
					format: 'rgb',
					hue: rgbDefaultColor,
				}),
			)
			this.addToAllSeries(
				imaVtsc,
				this.$t('withoutBark'),
				randomcolor({
					luminosity: 'dark',
					format: 'rgb',
					hue: rgbPrimaryColor,
				}),
			)
		},
		/**
		 * Seta serie para o Highcharts
		 */
		changeHighchartsOptions() {
			const series = this.allSeries.map((m) => m.serie)
			this.chartOptions.series = series
		},
		/**
		 * Evento de click no filtro do grafico
		 */
		esconderOuMostrarFazenda({ label: nomeDaFazenda, isChecked: isVisible }) {
			if (isVisible) {
				this.$refs.ref__chart.chart.get(nomeDaFazenda).show()
			} else {
				this.$refs.ref__chart.chart.get(nomeDaFazenda).hide()
			}
		},
	},
}
</script>

<style scoped>
.container__graficofazenda {
	display: grid;
	grid-template-areas: 'grafico';
	grid-template-columns: [grafico] 100%;
}

.container__graficofazenda__grafico {
	grid-area: grafico;
}
.container__graficofazenda__filtro {
	grid-area: filtro;
	max-height: 150px;
	display: flex;
	flex-direction: column;
}

@media screen and (min-width: 992px) {
	.container__graficofazenda {
		grid-template-areas: 'grafico filtro';
		grid-template-columns: [grafico] 3fr;
		min-height: 400px;
	}

	.container__graficofazenda__filtro {
		margin-left: 1rem;
		max-height: unset;
	}
}
</style>

<style>
.container__graficofazenda__tooltip {
	padding: 10px 10px 0 10px;
	line-height: 1rem;
	font-family: 'Open Sans', sans-serif;
	font-size: 0.75rem;
	color: white;
}

.container__graficofazenda__tooltip__fazenda {
	margin-bottom: 10px;
	padding-bottom: 10px;
}

.container__graficofazenda__tooltip__fazenda__nome {
	font-size: 1rem;
	display: flex;
	justify-content: center;
}

.container__graficofazenda__tooltip__fazenda__info {
	display: flex;
	justify-content: space-between;
}

.container__graficofazenda__tooltip__fazenda__info > span:first-child {
	color: var(--color-gray);
	margin-right: 0.5rem;
}
</style>
